import { SalesOrderStatus } from '../../constants/sales-order-status.js';
/** Inventory is committed but the order hasn't shipped yet -- pipeline exposure, not a receivable. */
export const IN_FLIGHT_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.ACCEPTED,
    SalesOrderStatus.DELIVERY_SCHEDULING,
    SalesOrderStatus.READY_TO_DELIVER,
]);
//# sourceMappingURL=in-flight-sales-order-status-ids.js.map